<template>
  <div class="wrapper">
    <!-- <div class="top">
      <div class="tabs">
        <div class="tab active">全部订单</div>
        <div class="tab">已审核</div>
        <div class="tab">待审核</div>
        <div class="tab">已退款</div>
        <div class="tab">已退货</div>
        <div class="tab">已完成</div>
      </div>
      <div class="search">
        <input type="text" v-model="searchOrder" placeholder="输入商品名称、商品编号、订单号" class="search-input">
        <div class="search-icon-wrap">
          <div class="search-icon">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
    </div>-->
    <div class="order-wrap">
      <div class="order-head order-box">
        <div class="order-info">商品</div>
        <div class="order-price">单价</div>
        <div class="order-num">售后类型</div>
        <div class="order-total-price">退款金额</div>
        <div class="order-state">售后状态</div>
        <div class="order-handle">操作</div>
      </div>
      <div v-if="list.length==0">暂无退换货记录</div>
      <div class="order-item" v-for="(item,index) in list" :key="index">
        <div class="order-item-head">
          <span class="time">{{timeToValue(item.ctime)}}</span>
          售后号：
          <span class="code">{{item.aftersales_id}}</span>
          订单号：
          <span class="code">{{item.order_id}}</span>
        </div>
        <div class="order-item-main order-box">
          <div class="order-info-list">
            <div class="order-li" v-for="(goods,i) in item.items" :key="i">
              <img :src="goods.image_url" alt class="order-img">
              <div class="order-name">{{goods.name}}</div>
              <div class="order-price">￥{{goods.price}}</div>
            </div>
          </div>
          <div class="order-type">{{item.type==1?'仅退款':'退款退货'}}</div>
          <div class="order-total-price">￥{{item.refund}}</div>
          <div class="order-state">
            <template v-if="item.status == 1">待审核</template>
            <template v-if="item.status == 2">审核通过</template>
            <template v-if="item.status == 3">审核拒绝</template>
          </div>
          <div class="order-handle">
            <router-link
              :to="{name:'refundDetail',params:{
              aftersales_id:item.aftersales_id
            }}"
            >查看详情</router-link>
          </div>
        </div>
      </div>
    </div>
    <template v-if="list.length>0">
      <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
    </template>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import { timeToDate } from "@/utils";
export default {
  name: "Refund",
  components: { Pagination },
  props: {},
  data() {
    return {
      searchOrder: "",
      page: 1,
      limit: 5,
      list: [],
      totalPage: 0
    };
  },
  watch: {},
  computed: {
    timeToValue() {
      return time => {
        return timeToDate(time);
      };
    }
  },
  methods: {
    getRefundList() {
      let data = {
        page: this.page,
        limit: this.limit
      };
      this.$api.afterSalesList(data).then(res => {
        if (res.status) {
          this.list = res.data.list;
          this.totalPage = res.data.total_page;
        }
      });
    },
    handOrderMore(val) {
      this.page = val;
      this.getRefundList();
    }
  },
  created() {},
  mounted() {
    this.getRefundList();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.order-item {
  border: 1px solid $border;
  box-sizing: border-box;
  margin-bottom: 20px;
  .order-item-head {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #757575;
    padding-left: 20px;
    border-bottom: 1px solid $border;
    .time {
      margin-right: 30px;
    }
    .code {
      margin-right: 30px;
    }
  }
}
.order-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  &.order-item-main {
    height: 100%;
    .order-info-list {
      border-right: 1px solid $border;
      width: 410px;
      .order-li {
        display: flex;
        align-items: center;
        &:not(:last-of-type) {
          border-bottom: 1px solid $border;
        }
        .order-img {
          display: block;
          width: 100px;
          height: 100px;
          object-fit: contain;
          margin-right: 10px;
        }
        .order-name {
          width: 200px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
    .order-type,
    .order-total-price,
    .order-state,
    .order-handle {
      padding-top: 40px;
    }
    .order-state {
      color: $theme-color;
    }
    .order-handle {
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
    }
  }
  &.order-head {
    @include line-height(40px);
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    margin: 20px 0;
  }
  .order-info {
    width: 310px;
    text-indent: 20px;
  }
  .order-price {
    width: 100px;
    text-align: center;
  }
  .order-num {
    width: 90px;
    text-align: center;
  }
  .order-type {
    width: 90px;
    text-align: center;
  }
  .order-total-price {
    width: 120px;
    text-align: center;
  }
  .order-state {
    width: 150px;
    text-align: center;
  }
  .order-handle {
    width: 150px;
    text-align: center;
  }
}
.wrapper {
  .top {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    align-items: center;
    .tabs {
      .tab {
        float: left;
        padding: 0 20px;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        &:first-of-type {
          padding-left: 0;
        }
        &:not(:last-of-type) {
          border-right: 1px solid $border;
        }
        &.active {
          color: $theme-color;
        }
        span {
          color: $theme-color;
        }
      }
    }
    .search {
      width: 265px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(220, 220, 220, 1);
      padding: 10px 0 10px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s;
      position: relative;
      &.active {
        border: 1px solid $theme-color;
      }
      .search-input {
        display: block;
        flex: 1;
        height: 20px;
      }
      .search-icon-wrap {
        display: inline-block;
        width: 40px;
        height: 40px;
        position: relative;
        border-left: 1px solid rgba(220, 220, 220, 1);
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: $theme-color;
        }
        &.active {
          border-color: $theme-color;
        }
        .search-icon {
          position: absolute;
          width: 20px;
          height: 20px;
          top: 10px;
          left: 10px;
          .el-icon-search {
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>